let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5EqMw")).then(() => parcelRequire('2EsuB'));